<!-- tap on top starts-->
<div
  class="tap-top"
  (click)="tapToTop()"
  [ngStyle]="{ display: show ? 'block' : 'none' }"
>
  <shared-feather-icons [icon]="'chevrons-up'"></shared-feather-icons>
</div>
<!-- tap on tap ends-->
